/******/ (() => { // webpackBootstrap
class ParallaxSection extends HTMLElement {
  constructor() {
    super();
    this._observer = null;
    this._onScroll = this._onScroll.bind(this);
  }

  connectedCallback() {
    this._img = this.querySelector('[data-parallax-image]');
    this._scribble = this.querySelector('[data-parallax-scribble]');
    this._container = this.closest('[data-parallax-container]');
    this._isPreviewMode = this.getAttribute('data-is-preview-mode') === 'true';

    if (!this._container || this._isPreviewMode) return;

    this._observer = new IntersectionObserver((entries) => {
      const entry = entries[0];

      if (entry.isIntersecting) {
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();
      } else {
        window.removeEventListener('scroll', this._onScroll);
      }
    }, { threshold: 0 });

    this._observer.observe(this);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._onScroll);
    this._observer?.disconnect();
  }

  _onScroll() {
    const rect = this._container.getBoundingClientRect();

    if (rect.bottom < 0 || rect.top > window.innerHeight) {
      return;
    }

    const containerHeight = this._container.offsetHeight;
    const BASE_OFFSET_PERCENT = 50;
    const FACTOR = 3.5;

    const isFirstSection =
      this._container === document.querySelector('#MainContent .shopify-section:first-of-type [data-parallax-container]');

    const halfViewportPx = Math.floor(window.innerHeight / 2);
    const BUFFER = isFirstSection ? 0 : halfViewportPx;
    const scrolled = window.scrollY - this._container.offsetTop + BUFFER;
    const scrollRatio = scrolled / containerHeight;

    /* =========================
       IMAGE PARALLAX
    ========================= */
    if (this._img) {
      let translateYPercent = BASE_OFFSET_PERCENT - (scrollRatio * FACTOR * 100);

      if (translateYPercent > BASE_OFFSET_PERCENT) {
        translateYPercent = BASE_OFFSET_PERCENT;
      }

      this._img.style.transform = `translate3d(0, ${translateYPercent}%, 0)`;
    }

    /* =========================
       SCRIBBLE DRAW-IN
    ========================= */
    if (this._scribble) {
      // starts slightly before section centre, finishes shortly after
      const start = 0.05;
      const end = 0.72;

      let progress = (scrollRatio - start) / (end - start);
      progress = Math.max(0, Math.min(1, progress));

      const easedProgress = 1 - Math.pow(1 - progress, 2);
      this._scribble.style.setProperty('--scribble-progress', easedProgress.toString());
    }
  }
}

if (!customElements.get('parallax-section')) {
  customElements.define('parallax-section', ParallaxSection);
}
/******/ })()
;